import { EInputIntents } from '@src/typings';
import { cva } from 'class-variance-authority';

// This function will be used to create input variants that respect the theme
export const inputVariants = cva(
    '!px-3 py-2 rounded-lg !shadow-none focus:border-2 disabled:opacity-60 transition-all',
    {
        variants: {
            intent: {
                [EInputIntents.filled]: '',
                [EInputIntents.outlined]: '',
            },
            size: {
                xs: 'text-xs',
                sm: 'text-xs',
                md: 'text-small',
                lg: 'text-base',
                xl: 'text-base',
            },
            error: {
                true: '!border-inputError',
                false: 'focus:border-inputFocusBorder !border-inputActiveBorder',
            },
        },
        compoundVariants: [],
        defaultVariants: {
            intent: EInputIntents.outlined,
            size: 'md',
            error: false,
        },
    }
);
